import { MyTableComponent, Input } from "components"
import { useState, useEffect } from "react"
import tittle from "./Tittle.png"
import slidersign from "./slidersign.png"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import { IDeviceList } from "types/IDeviceList"
import { useDeviceListMutation } from "../../store/Features/devices/deviceList-api-slice"
import redTick from "./redtick.png"
import greenTick from "./greentick.png"

export const DeviceError = () => {
 const [data, setData] = useState<IDeviceList[]>([])
 const [deviceList] = useDeviceListMutation()

 useEffect(() => {
  deviceList({ deviceId: [] })
   .then((res: any) => {
    setData(res.data)
   })
   .catch((e) => {
    console.log("e", e)
   })
 }, [])
 // language translator
 const { t } = useTranslation("translation")
 const columns = [
  { Header: t("center"), accessor: "server_name" },
  { Header: t("Device"), accessor: "device_name" },
  { Header: "Status", accessor: "device_status" },
  { Header: t("Location"), accessor: "location" },
  {
   Header: t("Condition"),
   accessor: "condition",
   Cell: ({ row }: any) => (
    <div className="flex items-center">
     <div
      className={` h-4 w-4 rounded mr-1 ${
       row.original.condition === "badly disturbed"
        ? "bg-red"
        : row.original.condition === "internal error"
          ? "bg-golden"
          : row.original.condition === "SP 0" || row.original.condition === "SP 4"
            ? "bg-green"
            : ""
      }`}
     ></div>
     <div>{row.original.condition}</div>
    </div>
   ),
  },
  { Header: t("operatingMode"), accessor: "operating_mode" },
  {
   Header: t("communication"),
   Cell: ({ row }: any) => (
    <div className="flex justify-center">
     {row.original.communication === "not ok" ? (
      <span>
       <img src={redTick} alt="selecticontwo" />
      </span>
     ) : (
      <span>
       <img src={greenTick} alt="selecticontwo" />
      </span>
     )}
    </div>
   ),
  },
  { Header: "since", accessor: "last_change" },
 ]

 const [selectedData, setSelectedData] = useState<any[]>([])

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
  // eslint-disable-next-line
 }, [data])

 const searchHandler = (keyword: any) => {
  if (keyword !== "") {
   const filterData: IDeviceList | any = data?.filter(
    (item) => item?.device_name?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== -1,
   )
   setSelectedData([...filterData])
  } else {
   const filterData: IDeviceList | any = data?.filter(
    (item) => item?.device_name?.toLowerCase()?.indexOf(keyword.toLowerCase()) !== 1,
   )
   setSelectedData([...filterData])
  }
 }

 return (
  <div className="relative h-screen md:h-screen lg:h-[85vh] w-[96%] mx-auto">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("tableHeading")}</h1>
    <div className="bg-white h-10 w-10 rounded flex justify-center items-center">
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <Box bg="highlight" color="text-black">
    <div className="py-3 px-3 flex justify-between items-center">
     <h1 className="Jakarta-font font-semibold">{t("Devices")}</h1>

     <div className="flex items-center justify-end">
      <p className="Jakarta-font">Category</p>

      <div className="bg-white h-8 w-12  mx-4  border-light-gray border-[1.5px] rounded flex justify-center items-center">
       <img className="w-4" src={tittle} alt="tittlesign" />
      </div>

      {/* ======== SearchHandler  ======== */}

      <div className="w-1/4 hover:w-[45%] transition-all delay-150 duration-700">
       <Input
        onChange={searchHandler}
        className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2    "
        placeholder="Search"
        type="search"
       />
      </div>
     </div>
    </div>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? selectedData : []}
    paginate={true}
   />
  </div>
 )
}
